import React, { useEffect, useState } from "react";
import {
    BoxWrapper,
    CustomMenuItem,
    StyledMenu,
    MenuContainer,
} from "./Styled";
import ArrowDownIcon from "../../svg/ArrowDownIcon";
import { SearchBarWrapper, SearchText } from "./Styled";
import SearchIcon from "../../svg/SearchIcon";

interface DropDownProps {
    menuText: string;
    handleSetAnchor: any;
    style?: any;
    isView?: boolean;
    disabled?: boolean;
}

const DropDown = ({
    menuText,
    handleSetAnchor,
    style,
    isView,
    disabled,
}: DropDownProps) => {
    return (
        <BoxWrapper
            onClick={handleSetAnchor}
            style={style}
            $disabled={isView || disabled}
        >
            {menuText}
            <ArrowDownIcon color="black" />
        </BoxWrapper>
    );
};

interface DropdownMenuProps {
    menuList: any[];
    menuText: string;
    handleOnclickItem: Function;
    style?: any;
    isView?: boolean;
    disabled?: boolean;
}

const DropdownMenuWithSearch = ({
    menuList,
    menuText,
    handleOnclickItem,
    style,
    isView,
    disabled,
}: DropdownMenuProps) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [anchorWidth, setAnchorWidth] = useState(0);
    const [searchText, setSearchText] = useState("");
    const [isFocus, setIsFocus] = useState(false);
    const open = Boolean(anchorEl);

    // Calculate minWidth based on longest provider name
    const longestName = React.useMemo(() => {
        return menuList.reduce((longest, item) => {
            const name = item.provider?.name || item.name || "";
            const currentLength = name.length;
            return currentLength > longest ? currentLength : longest;
        }, 0);
    }, [menuList]);

    const minWidth = Math.max(longestName * 8 + 48, anchorWidth);

    const filteredMenuList = React.useMemo(() => {
        if (!searchText.trim()) return menuList;

        const searchLower = searchText.toLowerCase().trim();
        return menuList.filter((item) => {
            const itemName = (
                item.provider?.name ||
                item.name ||
                ""
            ).toLowerCase();
            return itemName.includes(searchLower);
        });
    }, [menuList, searchText]);

    useEffect(() => {
        if (anchorEl) {
            setAnchorWidth(anchorEl.offsetWidth);
        }
    }, [anchorEl]);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSearchText("");
    };

    return (
        <>
            <DropDown
                menuText={menuText}
                handleSetAnchor={handleClick}
                style={style}
                isView={isView}
                disabled={disabled}
            />
            <StyledMenu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "basic-button",
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                slotProps={{
                    paper: {
                        style: {
                            minWidth: `${minWidth}px`,
                            width: "auto",
                            maxHeight: "auto",
                        },
                    },
                }}
            >
                <SearchBarWrapper isFocus={isFocus}>
                    <SearchIcon />
                    <SearchText
                        placeholder="Tìm kiếm..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        onFocus={() => setIsFocus(true)}
                        onBlur={() => setIsFocus(false)}
                    />
                </SearchBarWrapper>
                <MenuContainer>
                    {filteredMenuList.map((item: any) => (
                        <CustomMenuItem
                            key={item.provider?.name || item.name}
                            onClick={() => {
                                handleOnclickItem(item);
                                handleClose();
                            }}
                        >
                            {item.provider?.name || item.name}
                        </CustomMenuItem>
                    ))}
                </MenuContainer>
            </StyledMenu>
        </>
    );
};

export default DropdownMenuWithSearch;
